/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsDesignCollection,
    MelcoModelsDesignCollectionFromJSON,
    MelcoModelsDesignCollectionFromJSONTyped,
    MelcoModelsDesignCollectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsDesignCollection
 */
export interface MelcoModelsGenericList1MelcoModelsDesignCollection {
    /**
     * 
     * @type {Array<MelcoModelsDesignCollection>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignCollection
     */
    list: Array<MelcoModelsDesignCollection>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignCollection
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignCollection
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON(json: any): MelcoModelsGenericList1MelcoModelsDesignCollection {
    return MelcoModelsGenericList1MelcoModelsDesignCollectionFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsDesignCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsDesignCollectionToJSON(value?: MelcoModelsGenericList1MelcoModelsDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsDesignCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


